import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Divider, Button, Chip } from "@mui/material";
import { CreditCard } from "@mui/icons-material";
import { SPACING } from "../../theme/constants";
import { fetchSubscription } from "../../redux/slices/billingSlice";

const BillingCard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subscription, plan } = useSelector((state) => state.billing);

  useEffect(() => {
    dispatch(fetchSubscription());
  }, [dispatch]);

  const statusColor = {
    ACTIVE: "success",
    TRIALING: "info",
    PAST_DUE: "error",
    CANCELED: "default",
  };

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2.5,
        bgcolor: "background.paper",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <CreditCard sx={{ color: "primary.main" }} />
        <Typography variant="subtitle1" fontWeight={600}>
          Billing
        </Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />

      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Current Plan
        </Typography>
        <Typography variant="subtitle1" fontWeight={600}>
          {plan?.name || "Free"}
        </Typography>
      </Box>

      {subscription && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Status
          </Typography>
          <Chip
            label={subscription.status}
            size="small"
            color={statusColor[subscription.status] || "default"}
            sx={{ mt: 0.5 }}
          />
        </Box>
      )}

      <Button
        variant="outlined"
        size="small"
        fullWidth
        onClick={() => navigate("/dashboard/billing")}
        sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}
      >
        Manage Billing
      </Button>
    </Box>
  );
};

export default BillingCard;
